<template>
  <div class="footer">
    <div class="links">
      <a href="" target="_blank">Logistics {{ $t('main.index.homepage') }}</a>
      <a href="" target="_blank">
        <a-icon type="github"/>
      </a>
    </div>
    <div class="copyright">
      Copyright
      <a-icon type="copyright"/>
      2025 <span>Logistics {{ $t('homeData.produce') }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "LayoutFooter"
  }
</script>

<style lang="less" scoped>
  .footer {
    padding: 0 16px;
    margin: 48px 0 24px;
    text-align: center;

    .links {
      margin-bottom: 8px;

      a {
        color: rgba(0, 0, 0, .45);

        &:hover {
          color: rgba(0, 0, 0, .65);
        }

        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
    .copyright {
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
    }
  }
</style>